export const INITIAL_LOAD_EXECUTED =
  'INBOX_NEW/INITIAL_LOAD_EXECUTED';

export const SET_ACTIVE_TAB =
  'INBOX_NEW/SET_ACTIVE_TAB';

export const INITIALIZE_CONVERSATIONS_TAB =
  'INBOX_NEW/INITIALIZE_CONVERSATIONS_TAB';


export const SET_PREVIEWS_LOADING =
  'INBOX_NEW/SET_PREVIEWS_LOADING';

export const SET_PREVIEWS_LOADING_ERROR =
  'INBOX_NEW/SET_PREVIEWS_LOADING_ERROR';

export const SET_PREVIEWS_LOADING_SUCCESS =
  'INBOX_NEW/SET_PREVIEWS_LOADING_SUCCESS';

export const UPDATE_PREVIEWS =
  'INBOX_NEW/UPDATE_PREVIEWS';


export const SET_CONTACTS_LOADING =
  'INBOX_NEW/SET_CONTACTS_LOADING';

export const SET_CONTACTS_LOADING_ERROR =
  'INBOX_NEW/SET_CONTACTS_LOADING_ERROR';

export const SET_CONTACTS_LOADING_SUCCESS =
  'INBOX_NEW/SET_CONTACTS_LOADING_SUCCESS';


export const SET_CONVERSATION_LOADING =
  'INBOX_NEW/SET_CONVERSATION_LOADING';

export const SET_CONVERSATION_LOADING_ERROR =
  'INBOX_NEW/SET_CONVERSATION_LOADING_ERROR';

export const SET_CONVERSATION_LOADING_SUCCESS =
  'INBOX_NEW/SET_CONVERSATION_LOADING_SUCCESS';


export const SET_CONVERSATION_LOADING_MORE =
  'INBOX_NEW/SET_CONVERSATION_LOADING_MORE';

export const SET_CONVERSATION_LOADING_MORE_ERROR =
  'INBOX_NEW/SET_CONVERSATION_LOADING_MORE_ERROR';

export const SET_CONVERSATION_LOADING_MORE_SUCCESS =
  'INBOX_NEW/SET_CONVERSATION_LOADING_MORE_SUCCESS';


export const CREATE_CONVERSATION_LOADING =
  'INBOX_NEW/CREATE_CONVERSATION_LOADING';

export const CREATE_CONVERSATION_LOADING_ERROR =
  'INBOX_NEW/CREATE_CONVERSATION_LOADING_ERROR';

export const CREATE_CONVERSATION_LOADING_SUCCESS =
  'INBOX_NEW/CREATE_CONVERSATION_LOADING_SUCCESS';

export const RESET_CREATE_CONVERSATION_STATUS =
  'INBOX_NEW/RESET_CREATE_CONVERSATION_STATUS';


export const DELETE_CONVERSATION_LOADING =
  'INBOX_NEW/DELETE_CONVERSATION_LOADING';

export const DELETE_CONVERSATION_LOADING_ERROR =
  'INBOX_NEW/DELETE_CONVERSATION_LOADING_ERROR';

export const DELETE_CONVERSATION_LOADING_SUCCESS =
  'INBOX_NEW/DELETE_CONVERSATION_LOADING_SUCCESS';

export const RESET_DELETE_CONVERSATION_STATUS =
  'INBOX_NEW/RESET_DELETE_CONVERSATION_STATUS';


export const UNSET_CONVERSATION =
  'INBOX_NEW/UNSET_CONVERSATION';

export const ADD_MESSAGE =
  'INBOX_NEW/ADD_MESSAGE';


export const UPDATE_UPLOAD_PROGRESS =
  'INBOX_NEW/UPDATE_UPLOAD_PROGRESS';


export const DELETE_MESSAGE_LOADING =
  'INBOX_NEW/DELETE_MESSAGE_LOADING';

export const DELETE_MESSAGE_LOADING_ERROR =
  'INBOX_NEW/DELETE_MESSAGE_LOADING_ERROR';

export const DELETE_MESSAGE_LOADING_SUCCESS =
  'INBOX_NEW/DELETE_MESSAGE_LOADING_SUCCESS';

export const RESET_DELETE_MESSAGE_STATUS =
  'INBOX_NEW/RESET_DELETE_MESSAGE_STATUS';


export const SET_BAN_USER_LOADING =
  'INBOX_NEW/SET_BAN_USER_LOADING';

export const SET_BAN_USER_LOADING_ERROR =
  'INBOX_NEW/SET_BAN_USER_LOADING_ERROR';

export const SET_BAN_USER_LOADING_SUCCESS =
  'INBOX_NEW/SET_BAN_USER_LOADING_SUCCESS';

export const RESET_BAN_USER_STATUS =
  'INBOX_NEW/RESET_BAN_USER_STATUS';


export const MARK_AS_SPAM_LOADING =
  'INBOX_NEW/MARK_AS_SPAM_LOADING';

export const MARK_AS_SPAM_LOADING_ERROR =
  'INBOX_NEW/MARK_AS_SPAM_LOADING_ERROR';

export const MARK_AS_SPAM_LOADING_SUCCESS =
  'INBOX_NEW/MARK_AS_SPAM_LOADING_SUCCESS';

export const RESET_MARK_AS_SPAM_STATUS =
  'INBOX_NEW/RESET_MARK_AS_SPAM_STATUS';


export const SET_REPORT_ABUSE_LOADING =
  'INBOX_NEW/SET_REPORT_ABUSE_LOADING';

export const SET_REPORT_ABUSE_LOADING_ERROR =
  'INBOX_NEW/SET_REPORT_ABUSE_LOADING_ERROR';

export const SET_REPORT_ABUSE_LOADING_SUCCESS =
  'INBOX_NEW/SET_REPORT_ABUSE_LOADING_SUCCESS';

export const RESET_REPORT_ABUSE_STATUS =
  'INBOX_NEW/RESET_REPORT_ABUSE_STATUS';


export const SET_GROUP_CONVERSATION_LOADING =
  'INBOX_NEW/SET_GROUP_CONVERSATION_LOADING';

export const SET_GROUP_CONVERSATION_LOADING_ERROR =
  'INBOX_NEW/SET_GROUP_CONVERSATION_LOADING_ERROR';

export const SET_GROUP_CONVERSATION_LOADING_SUCCESS =
  'INBOX_NEW/SET_GROUP_CONVERSATION_LOADING_SUCCESS';


export const SET_GROUP_CONVERSATION_LOADING_MORE =
  'INBOX_NEW/SET_GROUP_CONVERSATION_LOADING_MORE';

export const SET_GROUP_CONVERSATION_LOADING_MORE_ERROR =
  'INBOX_NEW/SET_GROUP_CONVERSATION_LOADING_MORE_ERROR';

export const SET_GROUP_CONVERSATION_LOADING_MORE_SUCCESS =
  'INBOX_NEWSET_GROUP_CONVERSATION_LOADING_MORE_SUCCESS/';

export const ADD_GROUP_MESSAGE =
  'INBOX_NEW/ADD_GROUP_MESSAGE';


export const ACTION_NAMES = {
  INITIAL_LOAD_EXECUTED,
  SET_ACTIVE_TAB,
  INITIALIZE_CONVERSATIONS_TAB,
  SET_PREVIEWS_LOADING,
  SET_PREVIEWS_LOADING_ERROR,
  SET_PREVIEWS_LOADING_SUCCESS,
  UPDATE_PREVIEWS,
  SET_CONTACTS_LOADING,
  SET_CONTACTS_LOADING_ERROR,
  SET_CONTACTS_LOADING_SUCCESS,
  SET_CONVERSATION_LOADING,
  SET_CONVERSATION_LOADING_ERROR,
  SET_CONVERSATION_LOADING_SUCCESS,
  SET_CONVERSATION_LOADING_MORE,
  SET_CONVERSATION_LOADING_MORE_ERROR,
  SET_CONVERSATION_LOADING_MORE_SUCCESS,
  CREATE_CONVERSATION_LOADING,
  CREATE_CONVERSATION_LOADING_ERROR,
  CREATE_CONVERSATION_LOADING_SUCCESS,
  RESET_CREATE_CONVERSATION_STATUS,
  DELETE_CONVERSATION_LOADING,
  DELETE_CONVERSATION_LOADING_ERROR,
  DELETE_CONVERSATION_LOADING_SUCCESS,
  RESET_DELETE_CONVERSATION_STATUS,
  UNSET_CONVERSATION,
  ADD_MESSAGE,
  UPDATE_UPLOAD_PROGRESS,
  DELETE_MESSAGE_LOADING,
  DELETE_MESSAGE_LOADING_ERROR,
  DELETE_MESSAGE_LOADING_SUCCESS,
  RESET_DELETE_MESSAGE_STATUS,
  SET_BAN_USER_LOADING,
  SET_BAN_USER_LOADING_ERROR,
  SET_BAN_USER_LOADING_SUCCESS,
  RESET_BAN_USER_STATUS,
  MARK_AS_SPAM_LOADING,
  MARK_AS_SPAM_LOADING_ERROR,
  MARK_AS_SPAM_LOADING_SUCCESS,
  RESET_MARK_AS_SPAM_STATUS,
  SET_REPORT_ABUSE_LOADING,
  SET_REPORT_ABUSE_LOADING_ERROR,
  SET_REPORT_ABUSE_LOADING_SUCCESS,
  RESET_REPORT_ABUSE_STATUS,
  SET_GROUP_CONVERSATION_LOADING,
  SET_GROUP_CONVERSATION_LOADING_ERROR,
  SET_GROUP_CONVERSATION_LOADING_SUCCESS,
  SET_GROUP_CONVERSATION_LOADING_MORE,
  SET_GROUP_CONVERSATION_LOADING_MORE_ERROR,
  SET_GROUP_CONVERSATION_LOADING_MORE_SUCCESS,
  ADD_GROUP_MESSAGE,
};
